export const ENDPOINTS = {
  USER: "/user",
  HEADERS: "/headers",
  OFFERS: "/offers",
}

export default ENDPOINTS
